import { gql } from 'graphql-request'

export const UPDATE_BOOK_UNPUBLISH = gql`
  mutation SetBookUnpublishSchedule(
    $setBookUnpublishScheduleInput: SetBookUnpublishScheduleInput!
  ) {
    setBookUnpublishSchedule(
      setBookUnpublishScheduleInput: $setBookUnpublishScheduleInput
    ) {
      id
      publishedUntil
    }
  }
`
